import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataHandler } from 'C4';

import { language } from 'settings';

const Icon = (props) => {
  const { href, icon, size } = props;
  return (
    <a
      style={{ fontSize: !Number.isNaN(+size) ? `${size}rem` : size }}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="icons"
    >
      <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
    </a>
  );
};

export default class SocialIcons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: 0,
      icons: {}
    };
  }

  componentDidMount() {
    DataHandler.matchAppId().then((appId) => {
      this.setState({
        appId: appId,
      });
    });
  }

  render() {
    const { size, customIcons } = this.props;
    const { appId } = this.state;
    const filteredSocial = {};
    const socials = language.find(x => x.id === appId);

    if (!socials) {
      return (
        <div className="socialIcons">{icons}</div>
      );
    }

    Object.keys(customIcons).forEach((icon) => {
      if (socials.social[0][icon].length > 0) {
        filteredSocial[icon] = { icon: customIcons[icon], href: social[icon] };
      }
    });
  
    Object.keys(socials.social[0]).forEach((name) => {
      if (socials.social[0][name].length > 0 && filteredSocial[name] === undefined) {
        filteredSocial[`fab fa-${name}`] = socials.social[0][name];
      }
    });
  
    const icons = Object.keys(filteredSocial).map((name) => (
      <Icon
        key={name}
        href={filteredSocial[name].href || filteredSocial[name]}
        icon={filteredSocial[name].icon || name}
        size={size}
      />
    ));

    return (
      <div className="socialIcons">{icons}</div>
    );
  }
}

SocialIcons.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customIcons: PropTypes.shape(),
};

SocialIcons.defaultProps = {
  size: 'inherit',
  customIcons: {},
};

Icon.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Icon.defaultProps = {
  size: 'inherit',
};
